"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Image = _interopRequireDefault(require("../Image/Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Logo = function Logo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 80 : _ref$size,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-logo' : _ref$dataTestId;
  return /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    "data-test-id": dataTestId,
    src: "https://firebasestorage.googleapis.com/v0/b/uma-v2.appspot.com/o/_assets%2FlogoUma.png?alt=media&token=8601be70-67ec-48c0-a8fb-c0917253372e",
    alt: "Uma Logo",
    width: size
  });
};

var _default = Logo;
exports["default"] = _default;